import {WifiOff} from 'lucide-react';
import {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';

import {Alert, AlertDescription, AlertTitle} from '@/components/ui/alert';
import {toast} from '@/components/ui/use-toast';
import {useNetworkStatus} from '@/hooks/useNetworkStatus';

function OfflineStatusBanner() {
  const {t} = useTranslation();
  const isOnline = useNetworkStatus();
  const wasOffline = useRef(!isOnline);

  useEffect(() => {
    if (!isOnline) {
      wasOffline.current = true;
      return;
    }

    if (!wasOffline.current) {
      return;
    }

    wasOffline.current = false;
    toast({
      title: t('Back online'),
      description: t('The app can sync new data again.'),
      variant: 'success',
    });
  }, [isOnline, t]);

  if (isOnline) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-50 flex justify-center max-sm:bottom-24">
      <Alert variant="warning" className="pointer-events-auto max-w-[420px]">
        <WifiOff aria-hidden="true" />
        <AlertTitle>{t('Offline mode')}</AlertTitle>
        <AlertDescription>
          {t('Cached pages stay available. New changes need internet.')}
        </AlertDescription>
      </Alert>
    </div>
  );
}

export default OfflineStatusBanner;
